module.exports = __webpack_public_path__ + "static/media/fota_done.219e7b78.png";